import React, { useState, useEffect } from "react";
import { FaSave, FaTrash, FaPlus } from "react-icons/fa";
import { getUsers, updateUsers, createUsers, deleteUsers } from "../api";

const UserTable = () => {
  const [users, setUsers] = useState([]);

  const [editedUsers, setEditedUsers] = useState({});
  const [newUser, setNewUser] = useState({ uname: "", pass: "", is_admin: false });

  const handleChange = (id, field, value) => {
    setEditedUsers((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleSave = (id) => {
    const updated = users.map((user) =>
      user.id === id ? { ...user, ...editedUsers[id] } : user
    );
    setUsers(updated);
    setEditedUsers((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
    console.log(editedUsers[id], { ...updated[id], ...editedUsers[id] }, updated.filter((user) => user.id === id)[0]);
    updateUsers(id, updated.filter((user) => user.id === id)[0])
      .then(() => {
        alert('User updated successfully');
        console.log("User updated successfully");
      })
      .catch((error) => {
        alert('Error updating user');
        console.error("Error updating user:", error);
      });
  };

  const handleDelete = (id) => {
    const filtered = users.filter((user) => user.id !== id);
    setUsers(filtered);
    setEditedUsers((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
    deleteUsers(id)
      .then(() => {
        console.log("User deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const handleNewUserChange = (field, value) => {
    setNewUser((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddUser = () => {
    if (!newUser.uname.trim() || !newUser.pass.trim()) return;

    const nextId = users.length ? Math.max(...users.map((u) => u.id)) + 1 : 1;
    setUsers([...users, { id: nextId, ...newUser }]);
    setNewUser({ uname: "", pass: "", is_admin: false });
    createUsers(newUser)
      .then(() => {
        console.log("User added successfully");
      })
      .catch((error) => {
        console.error("Error adding user:", error);
      });
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUsers()
      .then((res) => {
        setUsers(res.data); setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching users:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">User Management</h2>
      </div>

      <table className="w-full table-auto border border-gray-300">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-4 py-2">ID</th>
            <th className="border px-4 py-2">Username</th>
            <th className="border px-4 py-2">Password</th>
            <th className="border px-4 py-2">Is Admin</th>
            <th className="border px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(({ id, uname, pass, is_admin }) => (
            <tr key={id}>
              <td className="border px-4 py-2 text-center">{id}</td>
              <td className="border px-4 py-2">
                <input
                  type="text"
                  value={editedUsers[id]?.uname ?? uname}
                  onChange={(e) => handleChange(id, "uname", e.target.value)}
                  className="w-full px-2 py-1 border rounded"
                />
              </td>
              <td className="border px-4 py-2">
                <input
                  type="text"
                  value={editedUsers[id]?.pass ?? pass}
                  onChange={(e) => handleChange(id, "pass", e.target.value)}
                  className="w-full px-2 py-1 border rounded"
                />
              </td>
              <td className="border px-4 py-2 text-center">
                <input
                  type="checkbox"
                  checked={editedUsers[id]?.is_admin ?? is_admin}
                  onChange={(e) => handleChange(id, "is_admin", e.target.checked)}
                />
              </td>
              <td className="border px-4 py-2 flex justify-center gap-4">
                <button
                  className="text-green-600 hover:text-green-800"
                  onClick={() => handleSave(id)}
                  title="Save"
                >
                  <FaSave />
                </button>
                <button
                  className="text-red-600 hover:text-red-800"
                  onClick={() => handleDelete(id)}
                  title="Delete"
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}

          {/* New User Row */}
          <tr>
            <td className="border px-4 py-2 text-center">—</td>
            <td className="border px-4 py-2">
              <input
                type="text"
                value={newUser.uname}
                onChange={(e) => handleNewUserChange("uname", e.target.value)}
                className="w-full px-2 py-1 border rounded"
                placeholder="Username"
              />
            </td>
            <td className="border px-4 py-2">
              <input
                type="text"
                value={newUser.pass}
                onChange={(e) => handleNewUserChange("pass", e.target.value)}
                className="w-full px-2 py-1 border rounded"
                placeholder="Password"
              />
            </td>
            <td className="border px-4 py-2 text-center">
              <input
                type="checkbox"
                checked={newUser.is_admin}
                onChange={(e) => handleNewUserChange("is_admin", e.target.checked)}
              />
            </td>
            <td className="border px-4 py-2 text-center text-gray-500 italic">
              <button
                className="flex items-center gap-2 px-4 py-2 rounded hover:bg-blue-700"
                onClick={handleAddUser}
              >
                <FaPlus /> Add User
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
